import {
  computed,
  Inject,
  inject,
  Injectable,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { IBanner } from '@web/dtos';
import { AppConfigService } from '../../app-config.service';
import { PREVIEW_TOKEN } from '../../../constants/injectionTokens.constant';

@Injectable({
  providedIn: 'root',
})
export class MockBannerStore {
  private readonly configService: AppConfigService = inject(AppConfigService);

  constructor(@Inject(PREVIEW_TOKEN) private previewData: IBanner) {}

  readonly isLoading: Signal<boolean> = signal(false);
  readonly banner: WritableSignal<IBanner> = signal(this.previewData);

  updateBanner(query: IBanner): void {
    this.banner.set(query);
  }

  save(query: IBanner): void {}

  bannerPath: Signal<string> = computed((): string => {
    return (
      this.configService.get().general.cmsUrl +
      '/images/' +
      this.banner().accessibleImage.image?.id
    );
  });
}
